import CompanyRegister from './CompanyRegister';

export default CompanyRegister;
